<template>
  <span>
    {{bucket?.label}}
  </span>
</template>

<script setup>
import {computed} from "vue";

const props = defineProps({
  value: {
    type: Number,
    required: true,
  },
  buckets: {
    type: Array,
    required: true,
  },
});

const bucket = computed(() => {
  return props.buckets.find((bucket) => {
    return props.value >= bucket.min && props.value <= bucket.max;
  });
});
</script>
